import React from 'react'
import './textarea.css'
import { TextareaPropsInterface } from '../../utils/constants/Interfaces.constants'
import useInputValidation from '../../hooks/useInputValidation'

const TextArea: React.FunctionComponent<TextareaPropsInterface> = ({
    labelFor = "",
    label,
    value,
    onChangeInput,
    name,
    required = false,
    maxLength,
    minLength,
    className = "",
    placeholder,
    disabled = false,
    showCount = true
}) => {

    const { bindValue, error } = useInputValidation()

  return (
    <div className="mf-admin-textarea-container d-flex flex-column">
        <textarea 
             className={'mf-admin-textarea ' + className}
             name={name}
             value={value} 
             onChange={onChangeInput} 
             required={required}
             minLength={minLength}
             maxLength={maxLength}
             placeholder={placeholder}
             disabled={disabled}
             { ...bindValue(name) }
        ></textarea>
        
        <div className="d-flex align-items-center justify-content-between textarea-order">
            {
                label?.length !== 0 ?
                <label className='text-primary-color weight-500 text-capitalize mf-admin-inputfield-label mb-1' htmlFor={labelFor}>{ label }</label> : <></>
            }
        </div>
        {/* <div className="d-flex align-items-center justify-content-between"> */}
        { error && <span className='error-text font-12 mt-2'>{error}</span>}
        {/* </div> */}
        {
            showCount &&
            <p className='mb-0 mt-2 font-13 weight-400 mf-admin-textarea-count'>{ value.length + '/' + maxLength }</p>
        }
    </div>
  )
}

export default TextArea